module.exports = __webpack_public_path__ + "08a6122cfa0dc893373c150b6c798720.svg";